import state from './uxState'
import mutations from './uxMutations'
import getters from './uxGetters'
import actions from './uxActions'

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}